export const COMPARE_COMPROVE_CONFIG = [
  {
    id: 2,
    // displayName: 'Ultrafarma.com.br',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-02.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-02-box.png',
  },
  {
    id: 3,
    // displayName: 'Panvel.com',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-03.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-03-box.png',
  },
  {
    id: 4,
    // displayName: 'drogasil.com.br',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-06.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-06-box.png',
  },
  {
    id: 5,
    // displayName: 'drogaraia.com.br',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-05.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-05-box.png',
  },

  {
    id: 6,
    // displayName: 'Drogariasaopaulo.com.br',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-08.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-08-box.png',
  },
  {
    id: 7,
    // displayName: 'Paguemenos.com.br',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-04.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-04-box.png',
  },
  {
    id: 8,
    // displayName: 'FarmaDelivery',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-10.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-10.jpg',
  },
  {
    id: 9,
    // displayName: 'Extrafarma',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-11.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-11.jpg',
  },
  {
    id: 10,
    // displayName: 'NovaEsperanca',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-16.jpg',
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-16-box.png',
    activeImage: true,
    active: true,
  },
  {
    id: 11,
    // displayName: 'DermaClub',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-15.png',
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-15.png',
    activeImage: true,
    active: true,
  },
  {
    id: 12,
    // displayName: 'EpocaCosmeticos',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-14.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-14.jpg',
  },
  {
    id: 13,
    // displayName: 'Beleza na Web',
    image: '/img/compare-e-comprove/Qualidoc-Concorrente-01.jpg',
    activeImage: true,
    active: true,
    boxImage: '/img/compare-e-comprove/Qualidoc-Concorrente-01-box.png',
  },
];
